import { BoardMemberProps } from "@/types/board";
import { BoardMemberCard } from "./BoardMemberCard";

interface BoardGridProps {
  members: BoardMemberProps[];
  startDelay?: number;
}

export const BoardGrid = ({ members, startDelay = 0 }: BoardGridProps) => {
  console.log("BoardGrid rendering with members:", members);
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
      {members.map((member, index) => {
        console.log(`Rendering board member ${index}:`, member);
        return (
          <BoardMemberCard
            key={member.name}
            {...member}
            delay={(index + startDelay) * 150}
          />
        );
      })}
    </div>
  );
};